export class Option {
	id: string = null;
	label: string = null;
}
